import { RootState } from "@/store/store";
import { explainWithAISliceSelector } from "@/store/explain-with-ai/selectors/slice-data/explainWithAISliceSelector";
import { ExplainWithAIState } from "@/store/explain-with-ai/utils/types/common";

export const explainWithAiWidgetDataSelector = (
  state: RootState,
): ExplainWithAIState["widgetData"] =>
  explainWithAISliceSelector(state).widgetData;
